import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core';
import { SFChip } from '../SFChip/SFChip';

export const useStateMandatedStyles = makeStyles({
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  asterisk: {
    display: 'none' // Hide asterisk only in this component
  }
});

export interface SFStateMandatedLabelProps {
  label: React.ReactNode | string | undefined;
  labelClassName?: string;
  required: boolean | undefined;
  missingInformation?: boolean | undefined;
}

export const SFStateMandatedLabel = ({
  label,
  labelClassName,
  required,
  missingInformation
}: SFStateMandatedLabelProps): React.ReactElement<SFStateMandatedLabelProps> => {
  const classes = useStateMandatedStyles();

  return (
    <span className={classes.labelWrapper}>
      <span className={`${labelClassName || ''}`}>{label || ''}</span>
      {required && (
        <Fragment>
          <SFChip
            sfColor='primary'
            size='tiny'
            variant='outlined'
            label='State-mandated'
          />
          {missingInformation && (
            <SFChip
              sfColor='default'
              size='tiny'
              variant='outlined'
              label='Missing information'
              hasError
            />
          )}
        </Fragment>
      )}
    </span>
  );
};
